import { render } from "./ThermometerMini.vue?vue&type=template&id=54d5fce8"
import script from "./ThermometerMini.vue?vue&type=script&lang=js"
export * from "./ThermometerMini.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__